import React from 'react';
import { HandshakeIcon, CheckIcon, MessageSquareIcon } from 'lucide-react';
export const ConsultingSection = () => {
  const services = ['Custom AI solution development', 'Growth strategy planning', 'Technical implementation', 'Ongoing support and optimization', 'Integration with existing systems', 'Training and knowledge transfer'];
  return <section className="py-24 border-t border-gray-100 relative" id="consulting" data-id="element-82">
      <div className="max-w-4xl mx-auto mb-12" data-id="element-83">
        <h2 className="font-serif text-4xl font-bold text-center mb-6" data-id="element-84">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-85">
            Consulting
          </span>
        </h2>
        <p className="text-lg text-gray-700 text-center mb-12" data-id="element-86">
          Custom AI growth tools built specifically for your creator business.
        </p>
      </div>
      <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden p-8" data-id="element-87">
        <div className="flex flex-col md:flex-row gap-8" data-id="element-88">
          <div className="md:w-1/2" data-id="element-89">
            <div className="bg-gradient-to-br from-orange-600 to-orange-500 text-white p-5 rounded-xl inline-flex mb-4" data-id="element-90">
              <HandshakeIcon className="w-10 h-10" data-id="element-91" />
            </div>
            <h3 className="font-serif text-3xl font-bold mb-4" data-id="element-92">
              Bespoke AI Solutions
            </h3>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-93">
              Our consulting service provides tailored AI solutions designed
              specifically for your creator business. We work closely with you
              to understand your unique challenges and opportunities, then build
              custom tools that help you grow faster and monetize more
              effectively.
            </p>
            <div className="bg-orange-50 p-6 rounded-lg border-l-4 border-orange-500 mb-6" data-id="element-94">
              <h4 className="font-medium text-xl mb-2" data-id="element-95">Why choose custom?</h4>
              <p className="text-gray-700" data-id="element-96">
                Generic tools can only take you so far. Custom AI solutions are
                built around your specific content, audience, and business model
                for maximum impact.
              </p>
            </div>
            <a href="https://calendar.app.google/adQ6vXNSxAWJgUqk8" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-orange-600 text-white font-medium rounded-lg hover:bg-orange-700 transition-all hover:shadow-lg flex items-center inline-flex" data-id="element-97">
              <MessageSquareIcon className="w-5 h-5 mr-2" data-id="element-98" />
              <span data-id="element-99">Schedule a Consultation</span>
            </a>
          </div>
          <div className="md:w-1/2" data-id="element-100">
            <div className="bg-gray-50 rounded-xl p-6 mb-6" data-id="element-101">
              <h4 className="font-medium text-xl mb-4" data-id="element-102">
                Our Consulting Services
              </h4>
              <ul className="space-y-3" data-id="element-103">
                {services.map((service, idx) => <li key={idx} className="flex items-start" data-id="element-104">
                    <CheckIcon className="w-5 h-5 text-orange-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-105" />
                    <span data-id="element-106">{service}</span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-107">
              <h4 className="font-medium text-lg mb-3 text-orange-600" data-id="element-108">
                Our Process
              </h4>
              <ol className="space-y-2" data-id="element-109">
                {['Discovery: We learn about your business and goals', 'Strategy: We develop a tailored AI implementation plan', 'Development: We build custom tools for your needs', 'Implementation: We integrate solutions with your workflow', 'Optimization: We continuously improve performance'].map((step, idx) => <li key={idx} className="flex items-start" data-id="element-110">
                    <span className="bg-orange-100 text-orange-600 rounded-full w-6 h-6 flex items-center justify-center mr-2 flex-shrink-0" data-id="element-111">
                      {idx + 1}
                    </span>
                    <span className="text-gray-700" data-id="element-112">{step}</span>
                  </li>)}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>;
};